import styled from "styled-components";

export const BrokerListContainer = styled.div`
  margin-top: 24px;
  width: 100%;
  ${({ $listHeight }) =>
    $listHeight &&
    `
      height: ${
        typeof $listHeight === "number" ? $listHeight + "px" : $listHeight
      };
      overflow-y: auto;
    `}
`;

export const InputSearchWrapper = styled.div`
  background-color: #f7f6fe;
  padding: 0 16px;
  width: 100%;
  border-radius: 100px;
  position: relative;
  height: 37px;
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  color: #222;
  font-family: inherit;
  padding: 0 0 0 36px;
  border-radius: 100px;
  height: 37px;
  min-width: 0;
  &::placeholder {
    color: #b3b3c6;
    opacity: 1;
  }
`;

export const ClearSearchButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  line-height: 1;
  padding: 0;
  color: #888;
`;
